import { Fragment, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import { DeclareRegisterInvoiceService as Service } from './DeclareRegisterInvoiceService';
import { TenantCompanyService } from '../../he-thong/doanh-nghiep/thong-tin-doanh-nghiep/TenantCompanyService';
import { TokenService } from '../../he-thong/chung-thu-so/TokenService';
import { LoadingService } from '../../../AppLoading';

import { AppStorage } from '../../../service/UserStorage';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';

import { useSign } from '../../../shared/component/Sign';

import { DialogViewTransferLog } from './component/DialogViewTransferLog';

import { Crup } from './component/crup';
import { useForm } from '../../../shared/hooks/Form';

import { ToastService } from '../../../AppToast';
import { useTranslation } from '../../../shared/language';

export const List = () => {

  const { t } = useTranslation();
  const header = t('menu.declaration');
  const dataKey = 'id';
  const idDefault = '00000000-0000-0000-0000-000000000000';
  const formalityRegister = 1;
  const formalityChange = 2;
  const { search } = useLocation();

  const [action, setAction] = useState(null);
  const [tenantCompany, setTenantCompany] = useState(null);
  const [formality, setFormality] = useState(1);
  const [createParam, setCreateParam] = useState(null);

  const [pdf, setPdf] = useState(null);
  const [displayPdf, setDisplayPdf] = useState(null);

  const [displayTransferLog, setDisplayTransferLog] = useState(false);

  const [tokens, setTokens] = useState([]);
  const [serviceProvider, setServiceProvider] = useState([])
  const [receivingUnitInformation, setReceivingUnitInformation] = useState([])
  const [allowanceAccessInfo, setAllowanceAccessInfo] = useState([])
  const [eInvoiceIntegrationRequest, setEInvoiceIntegrationRequest] = useState([])
  const [eInvoiceSuspensionRequest, setEInvoiceSuspensionRequest] = useState([])

  const [submitting, setSubmitting] = useState(false);
  const [displayFile, setDisplayFile] = useState(null);
  const [lastDeclaration, setLastDeclaration] = useState(null);

  const formalities = [
    { value: formalityRegister, label: t('common.declarationRegister') },
    { value: formalityChange, label: t('common.declarationChange') }
  ];

  const statuses = [
    { value: 0, label: t('common.notSubmitted') },
    { value: 1, label: t('common.submitted') }
  ];

  const feedbacks = [
    { value: 1, label: t('common.received') },
    { value: 2, label: t('common.notReceived') },
    { value: 3, label: t('common.accepted') },
    { value: 4, label: t('common.notAccepted') },
    { value: 5, label: t('common.explanation') }
  ];

  useEffect(() => {
    TenantCompanyService.get(AppStorage.get('tenant')).then(data => {
      setTenantCompany(data);
    });
  }, []);

  useEffect(() => {
    if (search) {
      const params = new URLSearchParams(search);
      setAction(params.get('action'));
      if (params.get('action') === 'create') {
        setFormality(2);
      }
    }
  }, [search]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (tenantCompany) {
      const _createParam = { ...tenantCompany };
      _createParam.formality = formality;
      setCreateParam(_createParam);

      if (action === 'create' && formality === 2) {
        doCreate(_createParam);
      }
    }
  }, [tenantCompany, formality, action]); // eslint-disable-line react-hooks/exhaustive-deps

  const { render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'formality', header: t('common.declarationType'), minWidth: 180, matchMode: 'contains', filterType: 'dropdown', filterOptions: formalities, dataType: 'fromFilterOptions' },
      { field: 'email', header: t('common.contactEmail'), minWidth: 160, matchMode: 'contains' },
      { field: 'dateCreate', header: t('common.declarationDate'), width: 120, matchMode: 'equals', filterType: 'date', dataType: 'date' },
      {
        field: 'status', header: t('common.submissionStatus'), width: 150, matchMode: 'contains', filterType: 'dropdown', filterOptions: statuses, dataType: 'custom', customCell(rowData: any): any {
          return <span className={`ss04-status ss04-status-${rowData.status}`}>{statuses[rowData.status]?.label}</span>;
        }
      },
      {
        field: 'taxAuthorityFeedback', header: t('common.taxAuthorityFeedback'), width: 150, matchMode: 'contains', filterType: 'dropdown', filterOptions: feedbacks, dataType: 'custom', customCell(rowData: any): any {
          if (typeof rowData.taxAuthorityFeedback === 'number') {
            return <span className={`underline ss04-feedback ss04-feedback-${rowData.taxAuthorityFeedback}`} onClick={() => setDisplayTransferLog(true)}>{feedbacks[(rowData.taxAuthorityFeedback - 1)]?.label}</span>;
          } else {
            return '';
          }
        }
      },
      { field: 'taxpayers', header: t('common.sender'), minWidth: 160, matchMode: 'contains' },
      { field: 'dateSign', header: t('common.sentDate'), width: 120, dataType: 'date' },
      {
        field: 'print', header: t('common.printView'), width: 70, sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return <i className="pi pi-print" onClick={() => print(rowData)}></i>
        }, style: { justifyContent: 'center' }
      },
      {
        field: 'download', header: t('common.downloadXml'), width: 70, sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return <i className="pi pi-download" onClick={() => downloadXml(rowData)}></i>
        }, style: { justifyContent: 'center' }
      }
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params).then(data => {
        let accept = false;
        if (data && data.items) {
          data.items.forEach(({ taxAuthorityFeedback }) => {
            if (taxAuthorityFeedback === 3) {
              accept = true;
            }
          });
        }
        setFormality(accept ? 2 : 1);
        return data;
      });
    }
  });

  const { renderSign, sign } = useSign({ onComplete: reloadLazyData });

  const print = (rowData) => {
    setPdf(Service.getPdfUrl(rowData.id));
    setDisplayPdf(true);

    LoadingService.start();
  }

  const onIframeLoad = () => {
    LoadingService.stop();
  }

  const downloadXml = (rowData) => {
    Service.downloadXml(rowData.id).then(data => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `${rowData['taxCode']}_to-khai-dang-ky.xml`;
      link.click();
    });
  }

  const reloadTokens = () => {
    TokenService.getList({ Used: true, maxResultCount: 1000 }).then(({ items }) => {
      if (items) {
        items.forEach(item => {
          if (item.dateFrom) {
            item.dateFrom = new Date(item.dateFrom);
          }
          if (item.expireDate) {
            item.expireDate = new Date(item.expireDate);
          }
        });
        setTokens(items);
      }
    });
  }

  const { render: renderDialogCrup, create, update, setValue } = Crup({ header, dataKey, tokens, setTokens, reloadTokens, refreshLazyData });
  // const { render: renderDialogCrup, create, update, setValue } = CrupND70({
  //   header,
  //   dataKey,
  //   tokens,
  //   setTokens,
  //   serviceProvider,
  //   setServiceProvider,
  //   receivingUnitInformation,
  //   setReceivingUnitInformation,
  //   allowanceAccessInfo,
  //   setAllowanceAccessInfo,
  //   eInvoiceIntegrationRequest,
  //   setEInvoiceIntegrationRequest,
  //   eInvoiceSuspensionRequest,
  //   setEInvoiceSuspensionRequest, reloadTokens, refreshLazyData, lastDeclaration
  // });

  const doCreate = (param) => {
    Service.extentsDeclaration().then(data => {
      if (data.id !== idDefault) {
        setLastDeclaration(data);
        data.dateCreate = new Date();
        data.formality = formalityChange;
        bildingData(data);
        setDataDefault(data, param);
        update(data);
        reloadTokens();
      } else {
        setLastDeclaration(data);
        create();
        bildingDataDefault(param);
        reloadTokens();
      }
    });
  }

  const bildingData = (data) => {
    if (data.dateCreate) {
      data.dateCreate = new Date(data.dateCreate);
    }
    if (data.formInvoice) {
      data.formInvoice = data.formInvoice.split(',');
    }
    if (data.formSendData) {
      data.formSendData = data.formSendData.split(',');
    }
    if (data.invoiceTypeUse) {
      data.invoiceTypeUse = data.invoiceTypeUse.split(',');
    }
    if (data.method) {
      data.method = data.method.split(',');
    }
  }

  const setDataDefault = (data, param) => {

    data.id = null;
    data.formality = param.formality || formalityRegister;
    data.dateCreate = new Date();
    data.region = param.province;
    data.taxpayers = param.name;
    data.taxCode = param.taxCode;
    data.cityCode = param.cityCode;
    data.cityName = param.cityName;
    data.taxAuthorityCode = param.taxAuthorityCode;
    data.taxAuthorityName = param.taxAuthorityName;
    data.address = param.address;

    if (param.email) {
      data.email = param.email;
    }
    if (param.delegate) {
      data.personContact = param.delegate;
    }
    if (param.tel) {
      data.phone = param.tel;
    }
  }

  const bildingDataDefault = (param) => {
    setValue({
      formality: param.formality || formalityRegister,
      dateCreate: new Date(),
      region: param.province,
      taxpayers: param.name,
      taxCode: param.taxCode,
      cityCode: param.cityCode,
      cityName: param.cityName,
      taxAuthorityCode: param.taxAuthorityCode,
      taxAuthorityName: param.taxAuthorityName,
      personContact: param.personContact,
      address: param.address,
      email: param.email,
      phone: param.tel,
    });
  }

  const { renderToolbar } = useToolbar({
    dataKey,
    // createParam,
    // create: doCreate,
    update: (item) => {
      Service.get(item.id).then(data => {
        bildingData(data);
        setTokens(data.token);
        setServiceProvider(
          (data?.partners || [])
            .filter(item => item.type === 0)
            .map(item => ({
              ...item,
              fromDate: item.fromDate ? new Date(item.fromDate) : item.fromDate,
              toDate: item.toDate ? new Date(item.toDate) : item.toDate
            })) || []
        )
        setReceivingUnitInformation(
          (data?.partners || [])
            .filter(item => item.type === 1).map(item => ({
              ...item,
              fromDate: item.fromDate ? new Date(item.fromDate) : item.fromDate,
              toDate: item.toDate ? new Date(item.toDate) : item.toDate
            })) || [])
        setAllowanceAccessInfo(data.dependentUnits)
        setEInvoiceIntegrationRequest(data.integrations)
        setEInvoiceSuspensionRequest(data.suspensions)
        update(data);
      });
    },
    reloadLazyData,
    selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    otherActions: [
      // {
      //   label: 'Ký và gửi CQT', icon: 'pi pi-fw pi-print', className: 'iam-toolbar iam-toolbar-help', command: () => {
      //     if (selectedItems && selectedItems['id']) {
      //       sign({
      //         "CommandName": "SignDeclaration",
      //         "Id": selectedItems['id']
      //       });
      //     }
      //   }
      // },
      // {
      //   label: 'Tải lên file chấp nhận', icon: 'pi pi-fw pi-print', className: 'iam-toolbar iam-toolbar-help', command: () => {
      //     if (selectedItems && selectedItems['id']) {
      //       setDisplayFile(true);
      //     }
      //   }
      // }
    ]
  });

  const { render: renderFormUpload, valid: formUploadValid, getValue: getUploadValue } = useForm({
    fields: [
      { field: 'fromDate', header: t('common.acceptanceTime'), required: true, type: 'Calendar', className: 'md:col-12' },
      { field: 'files', header: t('common.acceptanceFile'), required: true, type: 'file', InputFileProps: { accept: '.pdf' }, className: 'md:col-12 mb-1' }
    ]
  });

  const upload = () => {
    if (!submitting && formUploadValid() && selectedItems && selectedItems['id']) {
      setSubmitting(true);

      const { files } = getUploadValue();

      const formData = new FormData();
      formData.append('files', files);

      Service.getUploadFileAcceptance(selectedItems['id'], formData).then(() => {
        setDisplayFile(false);
        reloadLazyData();
        ToastService.success();
      }).finally(() => {
        setSubmitting(false);
      });
    }
  }

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
      {renderSign()}

      <Dialog header={t('common.pdf')} visible={displayPdf} style={{ width: '80rem' }} position="top"
        onHide={() => setDisplayPdf(false)}>
        {pdf &&
          <iframe className="template-preview" src={pdf} title="pdf-preview" onLoad={onIframeLoad} />
        }
      </Dialog>

      <DialogViewTransferLog display={displayTransferLog} setDisplay={setDisplayTransferLog} selectedItem={selectedItems} />

      <Dialog header={t('common.uploadAcceptanceFile')} visible={displayFile} style={{ width: '500px' }} position="top" onHide={() => setDisplayFile(false)}>
        {renderFormUpload()}
        <div className="flex justify-content-end mt-2">
          <Button label={t('common.save')} icon="pi pi-check" className="p-button-sm mr-2" onClick={upload} loading={submitting} />
          <Button label={t('common.close')} icon="pi pi-times" onClick={() => setDisplayFile(false)} className="p-button-outlined p-button-secondary p-button-sm" />
        </div>
      </Dialog>
    </Fragment>
  )
}
